import React, { useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { ProductsProvider } from './contexts/ProductsContext';
import { InventoryProvider } from './contexts/InventoryContext';
import { ToastProvider } from './contexts/ToastContext';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Filters from './components/Filters/Filters';
import ProductGrid from './components/ProductGrid/ProductGrid';
import PhotosSection from './components/PhotosSection/PhotosSection';
import CatalogPage from './components/CatalogPage/CatalogPage';
import AboutPage from './components/AboutPage/AboutPage';
import CheckoutPage from './pages/CheckoutPage';
import SuccessPage from './pages/SuccessPage';
import ProductDetailPage from './pages/ProductDetailPage';
import AdminPage from './pages/AdminPage';
import OrdersPage from './pages/OrdersPage';
import Footer from './components/Footer/Footer';
import InventoryNameSync from './components/InventoryNameSync/InventoryNameSync';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import './styles/variables.css';
import './styles/global.css';
import './styles/toast.css';
import './App.css';

const EMPTY_FILTERS = { sizes: [], colors: [], categories: [] };

const HomePage = () => {
  const [activeFilters, setActiveFilters] = useState(EMPTY_FILTERS);

  const handleToggleFilter = useCallback((type, value) => {
    setActiveFilters((prev) => {
      const current = prev[type] || [];
      const updated = current.includes(value)
        ? current.filter((v) => v !== value)
        : [...current, value];
      return { ...prev, [type]: updated };
    });
  }, []);

  return (
    <>
      <Hero />
      <main className="main-content">
        <div className="content-container">
          <Filters
            showColors
            showSizes
            activeFilters={activeFilters}
            onToggleFilter={handleToggleFilter}
          />
          <ProductGrid activeFilters={activeFilters} />
        </div>
      </main>
      <PhotosSection />
    </>
  );
};

const AppContent = () => {
  const navigate = useNavigate();

  const handleNavigate = (page) => {
    if (page === 'catalog') navigate('/catalog');
    else if (page === 'about') navigate('/about');
    else navigate('/');
  };

  return (
    <div className="App">
      <Header onNavigate={handleNavigate} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/catalog" element={<CatalogPage />} />
        <Route path="/produto/:productId" element={<ProductDetailPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/meus-pedidos" element={<OrdersPage />} />
      </Routes>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <CartProvider>
            <ProductsProvider>
              <InventoryProvider>
                <ToastProvider>
                  <InventoryNameSync />
                  <AppContent />
                </ToastProvider>
              </InventoryProvider>
            </ProductsProvider>
          </CartProvider>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
